import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'newsletter-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnDestroy {
    dispose$ = new Subject<boolean>();
    
  constructor() {

  }

  ngOnDestroy(): void {
    this.dispose$.next(true);
    this.dispose$.complete();
  }
}
